import { WidgetType, WidgetFooterType, WidgetHeaderType } from '../widget.types';
import { getGeolocation } from '../../../utils/utils';
export const widgetWeatherEditModalName = '@@widget/weather/edit';
export const WeatherWidgetConfig = {
    type: WidgetType.WEATHER,
    single: false,
    thumbnail: '/assets/images/dashboard/widget-catalog/weather.jpg',
    title: 'widget:weather:title',
    description: 'widget:weather:description',
    header: {
        type: WidgetHeaderType.GENERIC,
        actions: [
            {
                title: 'widget:weather:change_location',
                modal: widgetWeatherEditModalName,
            },
        ],
    },
    footer: {
        type: WidgetFooterType.EMPTY,
    },
    baseConfig: {
        type: WidgetType.WEATHER,
        w: 1,
        h: 2,
        x: 0,
        y: 0,
    },
    init: async ({ api }) => {
        const position = await getGeolocation();
        if (!position) {
            throw new Error('widget:widget:browser_location_settings');
        }
        const { coords } = position;
        const result = await api.geocoding.getLocationByCoords(coords.longitude, coords.latitude);
        if (!result) {
            throw new Error('widget:widget:browser_location_settings');
        }
        const { latitude, longitude, address, alias, placeId } = result;
        const config = { address, placeId, alias, latitude, longitude };
        return { type: WidgetType.WEATHER, config, w: 1, h: 2, x: 0, y: 0 };
    },
};
//# sourceMappingURL=WeatherWidgetConfig.js.map